import { render, staticRenderFns } from "./job-form.vue?vue&type=template&id=15dfd4d2&scoped=true&"
import script from "./job-form.vue?vue&type=script&lang=js&"
export * from "./job-form.vue?vue&type=script&lang=js&"
import style0 from "./job-form.vue?vue&type=style&index=0&id=15dfd4d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dfd4d2",
  null
  
)

export default component.exports